<div mdbModal #modal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div *ngIf="model != null" class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
        <img id="logo" [src]="model.logoUrl">
        <h5 class="modal-title w-100">{{model.label}}
        </h5>
      </div>
      <div class="modal-body">
        <div id="activate-content" class="align-items-center">
          <img id="activate-img" [src]="model.activateImageUrl">
          <div class="m-4">
            <div>{{ model.description }}</div>
            <br/>
            <div>{{ model.activateDescription }}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button type="button"
                     mdbBtn
                     appBg="primary"
                     brightness="normal"
                     appTextColor="primary"
                     (click)="activate()"
                     mdbWavesEffect> {{ model.activateLabel }}
        </button>
      </div>
    </div>
  </div>
</div>

